import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdChevronLeft } from 'react-icons/md';

const ChevronLeft: React.FC<IconBaseProps> = (props) => (
  <MdChevronLeft {...props} />
);

export default ChevronLeft;
